export class AdminLogEntry {
  lineNumber: number

  level: string

  timestamp: string | null

  message: string

  constructor(data: Partial<AdminLogEntry> = {}) {
    this.lineNumber = data.lineNumber ?? 0

    this.level = data.level ?? "RAW"

    this.timestamp = data.timestamp ?? null

    this.message = data.message ?? ""
  }
}
